// Bridge: isolates the cross-domain dependency on sales-tax choice modal.
export { ImportTransactionsChoiceModal } from '../../../sales-tax/transactions-tab/modal/ImportTransactionsChoiceModal';
